export function formatRecipeDuration(minutes?: number | null): string | null {
  if (minutes === null || minutes === undefined) return null;
  if (minutes <= 60) return `${minutes}m`;

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  if (remainingMinutes === 0) return `${hours}h`;
  return `${hours}h ${remainingMinutes}m`;
}

export function formatRecipeTotalTime(recipe: { preparationTimeMin?: number | null; cookingTimeMin?: number | null }): string | null {
  const prep = recipe.preparationTimeMin;
  const cook = recipe.cookingTimeMin;
  if (prep && cook) return formatRecipeDuration(prep + cook);
  if (prep) return formatRecipeDuration(prep);
  if (cook) return formatRecipeDuration(cook);
  return null;
}
